import { colors } from '@loggi/mar';

const assignmentListHeaderStyles = {
  faqButton: {
    color: colors.root[900]
  }
};

export default assignmentListHeaderStyles;
